import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BankAccountsStore } from '../store/bank-accounts.store';
import { MatSnackBar } from '@angular/material/snack-bar';

export const ownTransferGuard: CanActivateFn = (route, state) => {
  const bankAccountsStore = inject(BankAccountsStore);
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);

  const accounts = bankAccountsStore.bankAccounts();
  
  // Check if user has more than one account
  if (accounts && accounts.length > 1) {
    return true;
  }

  // If user has only one or no accounts, redirect to send page with error message
  snackBar.open(
    'Necesitas más de una cuenta para realizar transferencias entre tus cuentas',
    'Cerrar',
    {
      duration: 4000,
      panelClass: 'mat-snack-warning'
    }
  );

  router.navigate(['/send']);
  return false;
};